// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes bounceScale-data-v-59ce7956{0%{transform:scale(0)}}.btn-bounce-icon.active i[data-v-59ce7956]{animation:bounceScale-data-v-59ce7956 .3s cubic-bezier(0.17, 0.89, 0.32, 1.49)}@keyframes bounceScale-data-v-59ce7956{0%{transform:scale(0)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
